// D49: where a price came from. Chain: Candle -> Binance public (spot) -> manual (owner). The label is small and
// muted; the title says what it means. `stablecoin_parity` = valued 1:1, no lookup happened.
const LABEL: Record<string, string> = { candle: 'Candle', binance_public: 'Binance spot', manual: 'kézi', stablecoin_parity: '1:1' };
const TITLE: Record<string, string> = {
  candle: 'Az ár a Candle szolgáltatás 1 perces gyertyájából jött.',
  binance_public: 'A Candle nem adott árat, ezért a Binance nyilvános (spot) ára került be.',
  manual: 'Az árat kézzel adtad meg; a rendszer nem írja felül, csak megerősítéssel.',
  stablecoin_parity: 'Stablecoin: 1:1-nek számít (hipotézis), nincs ár-lekérdezés.',
};

export const priceSourceLabel = (source: string | null | undefined): string | null => (!source || source === 'none' ? null : (LABEL[source] ?? source));

/** Small muted source label; renders nothing for an unknown (null) source. */
export function PriceSourceLabel({ source }: { source: string | null | undefined }) {
  const text = priceSourceLabel(source);
  if (text === null || !source) return null;
  return (
    <>
      {' '}
      <span className="muted small price-src" data-testid="price-source" data-source={source} title={TITLE[source] ?? undefined}>{text}</span>
    </>
  );
}
